import {
  UserChangeEmailError,
  UserChangePasswordError,
  UserUpdateError,
} from '@app/graphql/types-and-hooks';
import { TransactionState } from '@app/store/domain';

export type AttendeeProfileData = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  headline: string;
  bio: string;
  linkedinUrl: string;
  twitterUrl: string;
  websiteUrl: string;
  deleteConfirmationPhrase: string;
  userLoggedInViaSso: boolean;
  image: {
    url: string;
    small?: string;
    large?: string;
    file?: File;
  };
};

type FormState = {
  isSubmitting: boolean;
  fieldErrors: Array<{
    fieldName: string;
    code: UserUpdateError['code'];
  }> | null;
};

type EmailFormState = {
  isSubmitting: boolean;
  isSuccess: boolean;
  fieldErrors: Array<{
    fieldName: string;
    code: UserChangeEmailError['code'];
  }> | null;
};

type PasswordFormState = {
  isSubmitting: boolean;
  isSuccess: boolean;
  fieldErrors: Array<{
    fieldName: string;
    code: UserChangePasswordError['code'];
  }> | null;
};

export type OwnedOrganizationsData = {
  id: string;
};

type DeleteAccountFormState = {
  isSubmitting: boolean;
  isSuccess: boolean;
  ownedOrganizations: OwnedOrganizationsData[] | null;
  isOwnedOrganizationsLoading: boolean;
  error: { message: string } | null;
};

export type State = {
  error: { message: string } | null;
  profileData: AttendeeProfileData | null;
  formState: FormState;
  emailFormState: EmailFormState;
  passwordFormState: PasswordFormState;
  deleteAccountFormState: DeleteAccountFormState;
} & TransactionState;

export const defaultState: State = {
  profileData: null,
  error: null,
  status: 'idle',
  formState: {
    isSubmitting: false,
    fieldErrors: null,
  },
  emailFormState: {
    isSubmitting: false,
    isSuccess: false,
    fieldErrors: null,
  },
  passwordFormState: {
    isSubmitting: false,
    isSuccess: false,
    fieldErrors: null,
  },
  deleteAccountFormState: {
    isSubmitting: false,
    isSuccess: false,
    ownedOrganizations: null,
    isOwnedOrganizationsLoading: false,
    error: null,
  },
};
